import React, { useState, useEffect, useRef } from 'react'

// Monaco Editor component for code/JSON editing

const MonacoEditor = ({ value, onChange, language = 'json', height = '400px', readOnly = false }) => {
    const editorRef = useRef(null);
    const containerRef = useRef(null);
    const [initialized, setInitialized] = useState(false);
    const isUserEditingRef = useRef(false);

    useEffect(() => {
        if (!containerRef.current || initialized) return;

        require.config({ paths: { vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.45.0/min/vs' } });
        require(['vs/editor/editor.main'], () => {
            const editor = monaco.editor.create(containerRef.current, {
                value: value || '',
                language: language,
                theme: 'vs-dark',
                readOnly: readOnly,
                automaticLayout: true,
                minimap: { enabled: false },
                fontSize: 13,
                lineNumbers: 'on'
            });

            editor.onDidChangeModelContent(() => {
                if (!readOnly && onChange) {
                    isUserEditingRef.current = true;
                    onChange(editor.getValue());
                }
            });

            editorRef.current = editor;
            setInitialized(true);
        });

        return () => {
            if (editorRef.current) {
                editorRef.current.dispose();
            }
        };
    }, []);

    // Only update editor value if changed externally (not by user)
    useEffect(() => {
        if (editorRef.current && initialized && !readOnly && !isUserEditingRef.current) {
            editorRef.current.setValue(value || '');
        }
        // Reset flag after external update
        isUserEditingRef.current = false;
    }, [value, initialized, readOnly]);

    return <div ref={containerRef} style={{ height, border: '1px solid #374151', borderRadius: '0.5rem' }} />;
};

export default MonacoEditor
